import React from 'react';
import SecurityDocumentRepository from '../components/SecurityDocuments/SecurityDocumentRepository';

const SecurityDocuments: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <SecurityDocumentRepository />
    </div>
  );
};

export default SecurityDocuments;
